import { API } from "@infra/api";
import { loadAttachment } from "@infra/browser/download";
import { MissionRuntime } from "@infra/missions/MissionRuntime";
import { MissionsLoader } from "@infra/missions/MissionsLoader";
import { makeMissionsUseCases } from "@app/missions";
import type { IAttachmentDownloader } from "@ports/browser/IAttachmentDownloader";

const attachmentDownloader: IAttachmentDownloader = {
	load: (attachment, recordId, responseType) => loadAttachment(attachment, recordId, responseType),
};

const missionLoader = new MissionsLoader({ downloader: attachmentDownloader });

/** The app's one mission runtime: constructing it loads nothing, so it stays off first paint. */
const missionRuntime = new MissionRuntime();

export const missionsUseCases = makeMissionsUseCases({
	missionLoader,
	missionRuntime,
	missionsApi: {
		updateCores: (jobId, cores) => API.Missions.updateCores(jobId, cores),
		deleteCores: (jobId, coreIds) => API.Missions.deleteCores(jobId, coreIds),
	},
	pathfinder: {
		findPath: (request, options) => API.Pathfinder.findPath(request, options),
		simulate: (request) => API.Pathfinder.simulate(request),
	},
});
